import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import {
  _t,
  getCookie,
  modalLoading,
  pagination,
  paginationLoading,
  showingData,
  searchedShowingData,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdDelete } from 'react-icons/md';
import Moment from "react-moment";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";
import DataTable from "../../../../common/DataTable";

const BankNameCrud = () => {
  const { t } = useTranslation();
  const history = useHistory();
  
  //getting context values here
  let {
    //common
    loading,
    setLoading,
  } = useContext(SettingsContext);

  let {
    getBankNameList,
    bankNameForSearch,
    setBankNameForSearch,
    //pagination
    dataPaginating,
  } = useContext(RestaurantContext);

  // States hook here
  let [newBankName, setNewBankName] = useState({
    name: "",
    edit: false,
    id: null,
    uploading: false,
  });

  //search result
  let [searchedBankName, setSearchedBankName] = useState({
    list: null,
    searched: false,
  });

  // Fetch data on first render
  useEffect(() => {
    getBankNameList();
  }, []);

  const handleSetNewBankName = (e) => {
    setNewBankName({ ...newBankName, [e.target.name]: e.target.value });
  };

  //Save New bank name
  const handleSaveNewBankName = (e) => {
    e.preventDefault();
    setNewBankName({
      ...newBankName,
      uploading: true,
    });
    const url = BASE_URL + `/settings/bank-name`;
    let formData = new FormData();
    formData.append("name", newBankName.name);

    return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setNewBankName({
          name: "",
          edit: false,
          id: null,
          uploading: false,
        });
        setBankNameForSearch(res.data);
        setSearchedBankName({
          ...searchedBankName,
          list: res.data,
        });
        setLoading(false);
        toast.success(`${_t(t("Bank Name has been added"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        document.getElementById('close-btn').click();
      })
      .catch(() => {
        setLoading(false);
        setNewBankName({
          ...newBankName,
          uploading: false,
        });
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  //set edit true & values
  const handleSetEdit = (item) => {
    setNewBankName({
      ...newBankName,
      name: item.name,
      id: item.id,
      edit: true,
    });
  };

  //update bank name
  const handleUpdateBankName = (e) => {
    e.preventDefault();
    setNewBankName({
      ...newBankName,
      uploading: true,
    });
    const url = BASE_URL + `/settings/bank-name`;
    let formData = new FormData();
    formData.append("id", newBankName.id);
    formData.append("name", newBankName.name);

    return axios
      .put(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setNewBankName({
          name: "",
          edit: false,
          id: null,
          uploading: false,
        });
        setBankNameForSearch(res.data[0]);
        setSearchedBankName({
          ...searchedBankName,
          list: res.data[0],
        });
        setLoading(false);
        toast.success(`${_t(t("Bank Name has been updated"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        document.getElementById('close-btn').click();
      })
      .catch(() => {
        setLoading(false);
        setNewBankName({
          ...newBankName,
          uploading: false,
        });
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };


  const getListData = () => {
    let list = searchedBankName.searched ? searchedBankName.list : bankNameForSearch;
    if (Array.isArray(list)) {
      return list;
    } else if (list && Array.isArray(list.data)) {
      return list.data;
    } else if (list && typeof list === 'object') {
      return [list];
    }
    return [];
  };

  const onClearSearch = () => {
    setSearchedBankName({ ...searchedBankName, searched: false });
    const searchInput = document.getElementById("bankSearchInput");
    if (searchInput) {
      searchInput.value = "";
    }
  };

  const COLUMNS = [
    {
      label: _t(t("S.No")),
      key: "s_n",
      render: (item, index) => {
        return (
          <span className="t-font-weight-normal sm-text">
            {index + 1}
          </span>
        );
      },
    },
    {
      label: _t(t("Bank Name")),
      key: "name",
    },
    {
      label: _t(t("Created At")),
      key: "created_at",
      render: (item) => {
        return item.created_at ? (
          <Moment format="DD/MM/YYYY">{item.created_at}</Moment>
        ) : (
          "-"
        );
      },
    },
    {
      label: _t(t("Action")),
      key: "action",
      render: (item) => {
        return (
          <div className="d-flex justify-content-center">
            <button
              className="btn btn-primary ml-2 rounded-sm del-btn"
              onClick={() => handleSetEdit(item)}
              data-toggle="modal"
              data-target="#addBankName"
            >
              <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>
            </button>

            <button
              className="btn btn-danger ml-2 rounded-sm del-btn"
              onClick={() => {
                handleDeleteConfirmation(item.id);
              }}
            >
              <MdDelete
                className="del-icon"
              />
            </button>
          </div>
        );
      },
    },
  ];

  //search here
  const handleSearch = (e) => {
    let searchInput = e.target.value.toLowerCase();
    if (searchInput.length === 0) {
      setSearchedBankName({ ...searchedBankName, searched: false });
    } else {
      let searchedList = bankNameForSearch?.filter((item) => {
        let lowerCaseItemName = item.name?.toLowerCase();
        return (lowerCaseItemName && lowerCaseItemName.includes(searchInput));
      });
      setSearchedBankName({
        ...searchedBankName,
        list: searchedList,
        searched: true,
      });
    }
  };

  //delete confirmation modal
  const handleDeleteConfirmation = (id) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">{_t(t("You want to delete this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleDeleteBankName(id);
                  onClose();
                }}
              >
                {_t(t("Yes, delete it!"))}
              </button>
              <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  //delete here
  const handleDeleteBankName = (id) => {
    setLoading(true);
    const url = BASE_URL + `/settings/delete-bank-name/${id}`;
    return axios
      .delete(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setBankNameForSearch(res.data[0]);
        setSearchedBankName({
          ...searchedBankName,
          list: res.data[0],
        });
        setLoading(false);
        toast.success(
          `${_t(t("Bank Name has been deleted successfully"))}`,
          {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          }
        );
      })
      .catch(() => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Bank Names"))}</title>
      </Helmet>

      {/* Add modal */}
      <div className="modal fade" id="addBankName" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content">
                <h5 className="text-capitalize fk-sm-card__title">
                  {!newBankName.edit
                    ? _t(t("Add new bank name"))
                    : _t(t("Update bank name"))}
                </h5>
              </div>
              <button
                type="button"
                id="close-btn"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {newBankName.uploading === false ? (
                <div key="fragment-bank-name-1">
                  <form
                    onSubmit={
                      !newBankName.edit
                        ? handleSaveNewBankName
                        : handleUpdateBankName
                    }
                    autoComplete="off"
                  >
                    <div>
                      <label htmlFor="name" className="form-label">
                        {_t(t("Bank Name"))}{" "}
                        <small className="text-danger">*</small>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        placeholder="e.g. Faysal Bank"
                        value={newBankName.name || ""}
                        required
                        onChange={handleSetNewBankName}
                      />
                    </div>

                    <div className="mt-4">
                      <div className="row d-flex justify-content-end align-items-center">
                        <div className="col-4">
                          <button
                            type="submit"
                            className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded"
                          >
                            {!newBankName.edit
                              ? _t(t("Save"))
                              : _t(t("Update"))}
                          </button>
                        </div>
                        <div className="col-4">
                          <button
                            type="button"
                            className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded"
                            data-dismiss="modal"
                          >
                            {_t(t("Close"))}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              ) : (
                <div key="fragment2">
                  <div className="text-center text-primary font-weight-bold text-uppercase">
                    {_t(t("Please wait"))}
                  </div>
                  {modalLoading(3)}
                  <div className="mt-4">
                    <div className="row d-flex justify-content-end align-items-center">
                      <div className="col-4">
                        <button
                          type="button"
                          className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded"
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                        >
                          {!newBankName.edit
                            ? _t(t("Save"))
                            : _t(t("Update"))}
                        </button>
                      </div>
                      <div className="col-4">
                        <button
                          type="button"
                          className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded"
                          data-dismiss="modal"
                        >
                          {_t(t("Close"))}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Add modal Ends*/}

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div className="row mx-2 gx-2 align-items-center">
                  {/* next page data spin loading */}
                  <CustomSpinLoader loading={loading || dataPaginating}/>
                  {/* spin loading ends */}

                  <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                    <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                      <ul className="t-list fk-breadcrumb">
                        <li className="fk-breadcrumb__list">
                          <span className="t-link fk-breadcrumb__link text-capitalize">
                            {!searchedBankName.searched
                              ? _t(t("Bank Name List"))
                              : _t(t("Search Result"))}
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-6 col-lg-7">
                      <div className="row gx-3 align-items-center">
                        {/* Search group */}
                        <div className="col-md-9 t-mb-15 mb-md-0">
                          <div className="input-group">
                            <div className="form-file">
                              <input
                                type="text"
                                id="bankSearchInput"
                                className="form-control border-0 form-control--light-1 rounded-left"
                                placeholder={_t(t("Search")) + ".."}
                                onChange={handleSearch}
                              />
                            </div>
                            <button
                              className="btn btn-primary px-4 rounded-right"
                              type="button"
                            >
                              <i className="fa fa-search text-white"></i>
                            </button>
                          </div>
                        </div>
                        <div className="col-md-3 t-mb-15 mb-md-0">
                          <button
                            type="button"
                            className="btn btn-primary w-100 px-2 text-uppercase sm-text"
                            data-toggle="modal"
                            data-target="#addBankName"
                            onClick={() => {
                              setNewBankName({
                                name: "",
                                edit: false,
                                id: null,
                                uploading: false,
                              });
                            }}
                          >
                            {_t(t("Add New"))}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <DataTable
                  loading={loading}
                  data={getListData()}
                  columns={COLUMNS}
                  emptyText="No data available"
                  pagination={{
                    isPageLoading: loading,
                    isPagination: false,
                  }}
                  searchPayload={{
                    isSearched: searchedBankName.searched,
                    onClearSearch,
                  }}
                />
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default BankNameCrud;
